import * as React from 'react';
import PropTypes from 'prop-types';

class AddPlayersForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            players: ""
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({
            players: event.target.value
        });
    }

    handleSubmit(event) {
        let players = this.state.players.split("\n").filter(function (name) {
            return name.trim().length > 0;
        });

        if (players.length >= 3 && players.length <= 6) {
            this.props.onSubmit(players);
        } else {
            this.setState({
                errorMessage: "Ai nevoie de 3-6 jucatori"
            });
        }

        event.preventDefault();
    }

    render() {
        return (
            <div className="add-players-form">
                <h2>Adauga jucatori</h2>
                <p>Nume jucatori, fiecare pe o linie.</p>

                <textarea
                    className="form-control"
                    value={ this.state.value }
                    onChange={ this.handleChange }
                    rows="6"
                ></textarea>

                <div className="message">
                    { this.state.errorMessage }
                </div>

                <button
                    className="btn btn-sm btn-success btn-block"
                    onClick={ this.handleSubmit }
                >
                    Adauga jucatorii
                </button>
            </div>
        );
    }
}

AddPlayersForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
};

export default AddPlayersForm;



// WEBPACK FOOTER //
// ./src/components/AddPlayersForm.js